import { ComboBox, DatePicker, IDropdownOption, PrimaryButton, TextField } from '@fluentui/react';
import React, { Dispatch, SetStateAction, useState } from 'react';
import useForceUpdate from '../../common/custom-hooks/useForceUpdate';
import CustomInputIfc from '../../lib/FormValidator/Form/CustomInputIfc';
import InputField from '../../lib/FormValidator/Form/InputField';
import ToggleInput from '../../lib/FormValidator/Form/ToggleInput';
import MessageCourier from '../../lib/MessageCourier';
// import { CostPerHour } from "../../system/license_type/CostPerHour";
import TimeTaxSupportSystemClient from '../../system/TimeTaxSupportSystemClient';
import CostPerHourForm from './CostPerHourForm';
import { DatePickerInput } from '../../lib/FormValidator/Form/DatePickerInput';
import useAsyncDataCourier from '../../common/custom-hooks/useAsyncDataCourier';
import DataDropdown from '../../lib/FormValidator/Form/DataDropdown';
import { formatStartingSelection } from '../../common/list-utils';
import { DateCustom } from '../../lib/DateCustom';
import { t } from 'i18next';

const currentYear = new Date().getFullYear();

const yearOptions: IDropdownOption[] = Array.from({ length: 6 }, (_, i) => {
  const year = currentYear + 1 - i;
  return {
    key: year.toString(),
    text: String(year),
  };
});

const monthOptions: IDropdownOption[] = [
  { key: '1', text: t('Enero') },
  { key: '2', text: t('Febrero') },
  { key: '3', text: t('Marzo') },
  { key: '4', text: t('Abril') },
  { key: '5', text: t('Mayo') },
  { key: '6', text: t('Junio') },
  { key: '7', text: t('Julio') },
  { key: '8', text: t('Agosto') },
  { key: '9', text: t('Septiembre') },
  { key: '10', text: t('Octubre') },
  { key: '11', text: t('Noviembre') },
  { key: '12', text: t('Diciembre') },
];

interface ICostPerHourDetailViewProps {
  system: TimeTaxSupportSystemClient;
  form: CostPerHourForm | undefined;
  courier: MessageCourier;
  onBlurCustomInput: (customInput: CustomInputIfc) => void;
  changeBlockUI: (state: boolean) => void;
}

const CostPerHourDetailView = ({ system, form, courier, onBlurCustomInput, changeBlockUI }: ICostPerHourDetailViewProps) => {
  const newForm = form?.getIdInput().getValue() === '';

  const [periodo, setPeriodo] = useState<string | null>(null);

  const collaborators = useAsyncDataCourier(
    () => {
      console.log({ periodo });

      if (!periodo) return Promise.resolve([]);

      return system.getCollaboratorSystem().getCollaboratorsAndHorasCheckeadas(periodo);
    },
    [system, periodo],
    courier,
    changeBlockUI,
  );

  const collaboratorOptions: IDropdownOption<any>[] = React.useMemo(() => {
    return collaborators
      ? collaborators.map((col) => {
          return {
            key: col.col_id,
            text: col.col_nombre + ' ' + col.col_apellido,
            data: col.col_id,
          };
        })
      : [];
  }, [collaborators]);

  const colId = form?.getColidInput().getValue();
  const year = form?.getYearInput().getValue();
  const month = form?.getMonthInput().getValue();

  React.useEffect(() => {
    if (!year || !month) return;
    const newPeriodo = `${year}-${String(month).padStart(2, '0')}`;
    setPeriodo(newPeriodo);

    // Resetear valores
    if (form && newForm) {
      console.log('RESETEANDO');
      const sapInput = form.getCodigoSapInput();
      sapInput.setValue('');
      onBlurCustomInput(sapInput);
      const colIdInput = form.getColidInput();
      colIdInput.setValue('');
      onBlurCustomInput(colIdInput);
    }
  }, [year, month, form, newForm]);

  React.useEffect(() => {
    if (!form) return;

    const sapInput = form.getCodigoSapInput();
    const colId = form.getColidInput().getValue();
    if (!collaborators || !colId) return;

    const selected = collaborators.find((c) => c.col_id === colId);
    const col_id_sap = selected?.col_id_sap ?? '';

    // Si el formulario es para crear
    if (newForm) {
      sapInput.setValue(col_id_sap);
      onBlurCustomInput(sapInput);
    } else {
      sapInput.setValue(col_id_sap);
      onBlurCustomInput(sapInput);
    }
  }, [colId, newForm, collaborators, form]);

  return (
    <>
      {form && (
        <div className="cost-form">
          <div className="cost-form-grid">
            {!newForm && (
              <div className="formItem">
                <TextField label="Id" value={form.getIdInput().getValue()} readOnly />
              </div>
            )}

            <div className="formItem">
              <ComboBox
                label="Año"
                options={yearOptions}
                selectedKey={form.getYearInput().getValue()}
                disabled={!newForm}
                onChange={(_, option) => {
                  if (!option) return;
                  const input = form.getYearInput();
                  input.setValue(option.key);
                  onBlurCustomInput(input);
                }}
              />
            </div>

            <div className="formItem">
              {collaboratorOptions?.length ? (
                <DataDropdown
                  input={form.getColidInput()}
                  label="Colaborador"
                  onBlur={onBlurCustomInput}
                  options={collaboratorOptions}
                  startingSelection={formatStartingSelection(form.getColidInput().getValue(), collaboratorOptions)}
                  disabled={!newForm}
                />
              ) : (
                <ComboBox label={t('Colaborador')} placeholder={t('Sin opciones')} autoComplete="off" allowFreeform options={[]} />
              )}
            </div>

            <div className="formItem">
              <ComboBox
                label="Mes"
                options={monthOptions}
                selectedKey={form.getMonthInput().getValue()}
                disabled={!newForm}
                onChange={(_, option) => {
                  if (!option) return;
                  const input = form.getMonthInput();
                  input.setValue(option.key);
                  onBlurCustomInput(input);
                }}
              />
            </div>

            <div className="formItem">
              <InputField label="Código SAP" input={form.getCodigoSapInput()} onBlur={onBlurCustomInput} disabled={!newForm} readOnly />
            </div>
            
            <div className="formItem">
              <InputField label="Costo por hora" input={form.getCostPHInput()} onBlur={onBlurCustomInput} />
            </div>

            <div className="formItem">
              <InputField label="Coeficiente valor agregado" input={form.getCoefInput()} onBlur={onBlurCustomInput} />
            </div>


            <div className="formItem">
              <InputField label="Nombre valor agregado" input={form.getAVNameInput()} onBlur={onBlurCustomInput} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CostPerHourDetailView;
